module.exports = __webpack_public_path__ + "img/เครื่องอัดเม็ดอาหาร.80395b7a.png";